import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Map as MapIcon } from "lucide-react";
import { MapThumb, MapViewer } from "@/components/PassageMaps";

export const ReaderMaps = ({ reference }) => {
  const [maps, setMaps] = useState(null);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    let active = true;
    setMaps(null);
    api.get("/maps/match", { params: { reference, limit: 8 } })
      .then(({ data }) => active && setMaps(data))
      .catch(() => active && setMaps([]));
    return () => { active = false; };
  }, [reference]);

  return (
    <aside data-testid="reader-maps" className="bg-card rounded-3xl border border-border p-6 lg:sticky lg:top-24 lg:max-h-[calc(100vh-7rem)] lg:overflow-y-auto">
      <div className="flex items-center gap-2 mb-4">
        <MapIcon className="w-5 h-5 text-gold" />
        <h3 className="font-serif text-2xl font-600 text-ink">Maps for this passage</h3>
      </div>
      {maps === null && <p className="text-sm text-ink/50">Finding maps…</p>}
      {maps?.length === 0 && (
        <p data-testid="reader-maps-empty" className="text-sm text-ink/55">No atlas maps for this passage yet.</p>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-1 gap-4">
        {maps?.map((m) => <MapThumb key={m.id} m={m} onOpen={setOpen} />)}
      </div>
      <Link to="/bible-maps" data-testid="reader-maps-gallery-link" className="inline-block mt-5 text-sm text-olive hover:text-gold">
        Browse the full atlas →
      </Link>
      <MapViewer map={open} onClose={() => setOpen(null)} />
    </aside>
  );
};
